import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import "./tutorial.scss";
import ArrowBack from '../../components/ArrowBack/ArrowBack';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ModalTutorial from "../../components/Modal/ModalTutorial";
import { openModalTutorial } from "../../store/actions/ModalsActions";

const Tutorials = (props) => {
    const history = useHistory();
    const breakpoint = useMediaQuery('(min-width:768px)');
    const { modalTutorial, openModalTutorial } = props

    const handleBackData = () => {
        history.push('/dashboard/membresia')
    };

    useEffect(() => {

    }, []);

    const handleOpenModalTutorials = (numerTutorial) => {
        openModalTutorial(true, numerTutorial)
    }   

    return (
        <div className="contentMainTutorial">
            <ModalTutorial />
            <div>
                <ArrowBack
                    left={100}
                    top="15%"
                    text="Regresar"
                />
                <div className="contentCardsTutorials">
                    <div className="cardsTutorials">
                        <p className="titleTutorials">Tutoriales</p>
                        <div className="displayFlexDirection">
                            <div className="cardTutorialsHome cardTutorials" onClick={() => handleOpenModalTutorials(0)}>
                                <div className="displayFlexDirection displayFlex" style={{width:"215px"}}>
                                    <div className="imgIcon iconHome" />
                                    <div>
                                        <p className="textTitulCard">Home</p>
                                        <p className="textSubTitleCard">Resumen de la plataforma</p>
                                    </div>

                                </div>
                            </div>
                            <div className="cardTutorialsProfile cardTutorials" onClick={() => handleOpenModalTutorials(1)}>
                                <div className="displayFlexDirection displayFlex" style={{width:"200px"}}>
                                    <div className="imgIcon iconProfile" />
                                    <div>
                                        <p className="textTitulCard">Perfil</p>
                                        <p className="textSubTitleCard">Tu carta de presentación</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="displayFlexDirection">
                            <div className="cardTutorialsAnalytics cardTutorials" onClick={() => handleOpenModalTutorials(2)}>
                                <div className="displayFlexDirection displayFlex" style={{width:"200px"}}>
                                    <div className="imgIcon iconAnalytics" />
                                    <div>
                                        <p className="textTitulCard">Analytics</p>
                                        <p className="textSubTitleCard">Datos de tu desempeño</p>
                                    </div>

                                </div>
                            </div>
                            <div className="cardTutorialsMembership cardTutorials" onClick={() => handleOpenModalTutorials(3)}>
                                <div className="displayFlexDirection displayFlex" style={{width:"230px"}}>
                                    <div className="imgIcon iconMembership" />
                                    <div>
                                        <p className="textTitulCard">Membresías</p>
                                        <p className="textSubTitleCard">Costos de nuestros servicios</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="displayFlexDirection ">
                            <div className="cardTutorialsMessages cardTutorials" onClick={() => handleOpenModalTutorials(4)}>
                                <div className="displayFlexDirection displayFlex" style={{width:"215px"}}>
                                    <div className="imgIcon iconMessages" />
                                    <div>
                                        <p className="textTitulCard">Mensajes</p>
                                        <p className="textSubTitleCard">Comunicación con clientes</p>
                                    </div>

                                </div>
                            </div>
                            <div className="cardTutorialsOpinions cardTutorials" onClick={() => handleOpenModalTutorials(5)}>
                                <div className="displayFlexDirection displayFlex" style={{width:"170px"}}>
                                    <div className="imgIcon iconOpinions" />
                                    <div>
                                        <p className="textTitulCard">Opiniones</p>
                                        <p className="textSubTitleCard">Retroalimentación</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="displayFlexDirection">
                            <div className="cardTutorialsLogros cardTutorials" onClick={() => handleOpenModalTutorials(6)}>
                                <div className="displayFlexDirection displayFlex" style={{width:"190px"}}>
                                    <div className="imgIcon iconLogros" />
                                    <div>
                                        <p className="textTitulCard">Logros</p>
                                        <p className="textSubTitleCard">Recompenzas internas</p>
                                    </div>

                                </div>
                            </div>
                            <div className="cardTutorialsPhoto cardTutorials" onClick={() => handleOpenModalTutorials(7)}>
                                <div className="displayFlexDirection displayFlex" style={{width:"190px"}}>
                                    <div className="imgIcon iconPhoto" />
                                    <div>
                                        <p className="textTitulCard">Foto perfil</p>
                                        <p className="textSubTitleCard">Cómo te ven</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};
const mapDispatchToProps = dispatch => ({
    openModalTutorial:(open, numerTutorial) => dispatch(openModalTutorial(open, numerTutorial)),
})

const mapStateToProps = (state) => ({
    laywerUid: state.authClient.uid,
    modalTutorial: state.ModalReducer.modalTutorial,
    role: state.authClient.role,
});

export default connect(mapStateToProps, mapDispatchToProps)(Tutorials);